import { useEffect } from "react";
import { captureReferral } from "../utils/rewardful";

/**
 * Mirrors the Rewardful referral into localStorage on app boot.
 *
 * Runs once per page load rather than per route change: Rewardful's script only
 * parses the URL at load time, and affiliate links are always full page loads
 * from an external site.
 */
export default function RewardfulTracker() {
  useEffect(() => {
    captureReferral();
  }, []);

  return null;
}
